import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=24a50b52&scoped=true"
import script from "./Dashboard.js?vue&type=script&lang=js&external"
export * from "./Dashboard.js?vue&type=script&lang=js&external"
import style0 from "./Dashboard.scss?vue&type=style&index=0&id=24a50b52&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a50b52",
  null
  
)

export default component.exports